var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    _vm._b(
      {
        ref: "modal",
        attrs: {
          id: _vm.id,
          "no-close-on-backdrop": _vm.backdrop === "static",
          centered: _vm.modalDialogCentered,
          scrollable: _vm.modalDialogScrollable,
          size: _vm.modalDialogSize,
          "modal-class": "form-page extra-modal " + _vm.modalClass,
          "content-class": _vm.contentClass,
          "hide-header": !_vm.modalHeader,
          "hide-footer": !_vm.modalFooter,
          "no-enforce-focus": _vm.noEnforceFocus,
        },
        on: {
          show: _vm._handleModalShow,
          shown: _vm._handleModalShown,
          hide: _vm._handleModalHide,
          hidden: _vm._handleModalHidden,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "modal-header",
              fn: function (slotProps) {
                return [
                  !_vm.loading || _vm.loadersDisabled
                    ? [
                        _vm._t(
                          "header-custom",
                          function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "modal-title bold d-flex align-items-center",
                                },
                                [_vm._t("header")],
                                2
                              ),
                            ]
                          },
                          null,
                          slotProps
                        ),
                        _vm._v(" "),
                        _vm.headerCloseButton
                          ? _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return slotProps.close()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._t("header-loader", function () {
                        return [
                          _c("default-header-loader", {
                            staticClass: "w-100 h-100",
                          }),
                        ]
                      }),
                ]
              },
            },
            {
              key: "default",
              fn: function (slotProps) {
                return [
                  !_vm.loading || _vm.loadersDisabled
                    ? _vm._t("body", null, null, slotProps)
                    : _vm._t("body-loader", function () {
                        return [
                          _c("default-body-loader", {
                            staticClass: "w-100 h-100",
                          }),
                        ]
                      }),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function (slotProps) {
                return [
                  _vm.footerCloseButton
                    ? _c(
                        "b-button",
                        {
                          staticClass: "float-right cancel-modal btn-sm mr-2",
                          attrs: { variant: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.hide()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(_vm.computedFooterCloseButtonText) +
                              "\n    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading || _vm.loadersDisabled
                    ? _vm._t("footer", null, null, slotProps)
                    : _vm._t("footer-loader", function () {
                        return [
                          _c("default-footer-loader", {
                            staticClass: "w-100 h-100",
                          }),
                        ]
                      }),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.modalVisible,
          callback: function ($$v) {
            _vm.modalVisible = $$v
          },
          expression: "modalVisible",
        },
      },
      "b-modal",
      Object.assign({}, _vm.$attrs, _vm.$props),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }